import { render, staticRenderFns } from "./couponsTab.vue?vue&type=template&id=6b5566e8&scoped=true&"
import script from "./couponsTab.vue?vue&type=script&lang=js&"
export * from "./couponsTab.vue?vue&type=script&lang=js&"
import style0 from "./couponsTab.vue?vue&type=style&index=0&id=6b5566e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5566e8",
  null
  
)

export default component.exports